var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 51.724,
    viewBox: "0 0 50 51.724",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#b1b3b3;}.b{fill:#00a9e0;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1.688 -1.125)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M48.267,14.319a14.031,14.031,0,0,0-7.022-3.637,1.722,1.722,0,0,1-1.206-.963,15.232,15.232,0,0,0-4.546-5.69,14.428,14.428,0,0,0-8.806-2.9A15.179,15.179,0,0,0,16.612,4.9a16.96,16.96,0,0,0-5.218,9.18,1.723,1.723,0,0,1-1.263,1.3,10.719,10.719,0,0,0-5.3,2.627,9.277,9.277,0,0,0-3.14,7.157,9.491,9.491,0,0,0,3.5,7.76,12.623,12.623,0,0,0,7.923,2.422H38.326A13.908,13.908,0,0,0,47.7,31.9a12.013,12.013,0,0,0,3.988-9.04A11.73,11.73,0,0,0,48.267,14.319Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M8.461,34.431a1.711,1.711,0,0,1-1.422-2.66l3.422-5.134a1.712,1.712,0,0,1,2.847,1.9L9.886,33.67A1.711,1.711,0,0,1,8.461,34.431Z",
    transform: "translate(2.706 13.285)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M11.835,39.564a1.711,1.711,0,0,1-1.421-2.66l6.845-10.267a1.712,1.712,0,1,1,2.847,1.9L13.262,38.8A1.711,1.711,0,0,1,11.835,39.564Z",
    transform: "translate(4.52 13.285)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M19.711,34.431a1.711,1.711,0,0,1-1.422-2.66l3.422-5.134a1.712,1.712,0,0,1,2.847,1.9L21.136,33.67A1.711,1.711,0,0,1,19.711,34.431Z",
    transform: "translate(8.718 13.285)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M23.086,39.564a1.711,1.711,0,0,1-1.422-2.66l6.845-10.267a1.712,1.712,0,1,1,2.847,1.9L24.511,38.8a1.711,1.711,0,0,1-1.425.761Z",
    transform: "translate(10.544 13.285)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRain);
export default __webpack_public_path__ + "static/media/rain.5eb00ff3926e501f0ea1866e0392a61e.svg";
export { ForwardRef as ReactComponent };